// extracted by mini-css-extract-plugin
module.exports = {"carCard":"_1a4vE","shimmer":"_3LDqM","shimmerImgHeading":"LSyo9","shimmerImgContent":"_2BGcb"};